import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'footer-component',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
    @Input() banner_txt: string;
    @Input() displaySalesBanner: boolean = false;
    @Input() partnerId: string;

    constructor() { }

    ngOnInit() {
    }



}
